import { render } from "./CContent.vue?vue&type=template&id=62beeb90&scoped=true"
import script from "./CContent.vue?vue&type=script&lang=js"
export * from "./CContent.vue?vue&type=script&lang=js"

import "./CContent.vue?vue&type=style&index=0&id=62beeb90&scoped=true&lang=scss"

import exportComponent from "/builds/advocacy/e-advokat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62beeb90"]])

export default __exports__